__turbopack_context__.v({
  "avatar": "PlasmicHomeBenefitsSectionRoleDropdownItem-module__8xOuwa__avatar",
  "img": "PlasmicHomeBenefitsSectionRoleDropdownItem-module__8xOuwa__img",
  "imgpov_administrator": "PlasmicHomeBenefitsSectionRoleDropdownItem-module__8xOuwa__imgpov_administrator",
  "imgpov_officer": "PlasmicHomeBenefitsSectionRoleDropdownItem-module__8xOuwa__imgpov_officer",
  "item": "PlasmicHomeBenefitsSectionRoleDropdownItem-module__8xOuwa__item",
  "itemactive": "PlasmicHomeBenefitsSectionRoleDropdownItem-module__8xOuwa__itemactive",
  "name": "PlasmicHomeBenefitsSectionRoleDropdownItem-module__8xOuwa__name",
  "nameactive": "PlasmicHomeBenefitsSectionRoleDropdownItem-module__8xOuwa__nameactive",
  "role": "PlasmicHomeBenefitsSectionRoleDropdownItem-module__8xOuwa__role",
  "roleactive": "PlasmicHomeBenefitsSectionRoleDropdownItem-module__8xOuwa__roleactive",
  "svg": "PlasmicHomeBenefitsSectionRoleDropdownItem-module__8xOuwa__svg",
  "svgpov_administrator": "PlasmicHomeBenefitsSectionRoleDropdownItem-module__8xOuwa__svgpov_administrator",
  "svgpov_officer": "PlasmicHomeBenefitsSectionRoleDropdownItem-module__8xOuwa__svgpov_officer",
  "text": "PlasmicHomeBenefitsSectionRoleDropdownItem-module__8xOuwa__text",
});
